const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  slide: [],
  slideId: null,
  fetchSlide: {
    fetching: false,
    fetched: false
  },
  maxValue: "",
  minValue: "",
  annexeCategory: null,
  nbrOfYears: "",
  slideAction: "compose",
  ComponentAction: "ADD",
  componentConfig: {
    labels: { fr: "", en: "", nl: "" },
    componentId: "",
    type: "",
    indicators: [],
    config: [],
    data: []
  },
  composition: {
    sideBar: "slideConfiguration",
    labels: { fr: "", en: "", nl: "" },
    isPublic: false,
    isEditable: 0,
    organizations: "",
    SlideIndicators: [],
    selectedComponent: "",
    layout: {
      selectedCase: "",
      label: "test",
      type: "LAYOUT_3",
      config: {
        background: "#F3FAFF",
        componentsBackground: "#FFFFFF"
      },
      components: {}
    }
  },
  error: null
};

export const slideCompositionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_SLIDE_COMPOSITION": {
      return {
        ...initialState,
        composition: {
          ...initialState.composition,
          layout: {
            ...initialState.composition.layout,
            components: {}
          }
        }
      };
    }
    case "INIT_COMPONENT_ACTION": {
      return {
        ...state,
        ComponentAction: "ADD"
      };
    }
    case "CONFIG_YEARS": {
      return {
        ...state,
        nbrOfYears: action.nbrYears
      };
    }
    case "INIT_COMPONENT_CONFIG": {
      return {
        ...state,
        componentConfig: {
          labels: { fr: "", en: "", nl: "" },
          type: "",
          indicators: [],
          config: [],
          data: []
        }
      };
    }
    case "SET_COMPONENT": {
      return {
        ...state,
        componentConfig: action.newConfig
      };
    }
    case "SET_COMPONENT_ACTION": {
      return {
        ...state,
        ComponentAction: action.componentAction
      };
    }
    case "SET_SELECTED_EXPLANATION": {
      return {
        ...state,
        selectedExplanation: action.selectedIndicator
      };
    }
    case "SET_SLIDE_ACTION": {
      return {
        ...state,
        slideAction: action.slideAction
      };
    }
    case "SET_SLIDE_COMPOSITION_LABELS": {
      return {
        ...state,
        composition: { ...state.composition, labels: action.labels }
      };
    }
    case "SET_SLIDE_COMPOSITION_IS_PUBLIC": {
      return {
        ...state,
        composition: { ...state.composition, isPublic: action.isPublic }
      };
    }
    case "SET_SLIDE_IS_EDITABLE": {
      return {
        ...state,
        composition: { ...state.composition, isEditable: action.isEditable }
      };
    }
    case "SET_SLIDE_ID": {
      return {
        ...state,
        composition: { ...state.composition, slideId: action.slideId }
      };
    }
    case "SET_SIDE_BAR": {
      return {
        ...state,
        composition: { ...state.composition, sideBar: action.sideBar }
      };
    }
    case "SET_SLIDE_LAYOUT": {
      return {
        ...state,
        composition: {
          ...state.composition,
          layout: { ...state.composition.layout, type: action.layout }
        }
      };
    }
    case "SET_FOND_COLOR": {
      return {
        ...state,
        composition: {
          ...state.composition,
          layout: {
            ...state.composition.layout,
            config: {
              ...state.composition.layout.config,
              background: action.color
            }
          }
        }
      };
    }
    case "SET_BACK_GROUND_COMPONENT_COLOR": {
      return {
        ...state,
        composition: {
          ...state.composition,
          layout: {
            ...state.composition.layout,
            config: {
              ...state.composition.layout.config,
              componentsBackground: action.color
            }
          }
        }
      };
    }
    case "SET_SELECTED_CASE": {
      return {
        ...state,
        composition: {
          ...state.composition,
          layout: {
            ...state.composition.layout,
            selectedCase: action.selectedCase
          }
        }
      };
    }

    case "SET_SELECTED_COMPONENT": {
      return {
        ...state,
        composition: {
          ...state.composition,
          selectedComponent: action.selectedComponent
        }
      };
    }
    case "SET_INDICATOR": {
      return {
        ...state,
        composition: {
          ...state.composition,
          SlideIndicators: action.indicator
        }
      };
    }
    case "ADD_COMPONENT": {
      return {
        ...state,
        fetchSlide: {
          fetching: true
        },
        composition: {
          ...state.composition,
          layout: {
            ...state.composition.layout,
            components: action.component
          }
        }
      };
    }
    case "SET_SLIDE_COMPONENT_LABELS": {
      return {
        ...state,
        componentConfig: { ...state.componentConfig, labels: action.labels }
      };
    }
    case "ADD_COMPONENT_CONFIG": {
      return {
        ...state,
        componentConfig: {
          ...state.componentConfig,
          config: action.config
        }
      };
    }
    case "ADD_COMPONENT_TYPE": {
      return {
        ...state,
        componentConfig: {
          ...state.componentConfig,
          type: action.componentType
        }
      };
    }
    case "ADD_COMPONENT_INDICATOR": {
      return {
        ...state,
        componentConfig: {
          ...state.componentConfig,
          indicators: action.indicator
        }
      };
    }
    case "ADD_COMPONENT_LABELS": {
      return {
        ...state,
        componentConfig: {
          ...state.componentConfig,
          labels: action.labels
        }
      };
    }
    case "ADD_MIN_VALUE": {
      return {
        ...state,
        minValue: action.minValue
      };
    }
    case "ADD_MAX_VALUE": {
      return {
        ...state,
        maxValue: action.maxValue
      };
    }
    case "ADD_COMPONENT_DATA": {
      return {
        ...state,
        componentConfig: {
          ...state.componentConfig,
          data: action.data
        }
      };
    }
    case "ADD_NUMBER_OF_YEAR": {
      return {
        ...state,
        componentConfig: {
          ...state.componentConfig,
          config: action.yearsNumber
        }
      };
    }
    case "ADD_ANNEXE_CATEGORY": {
      return {
        ...state,
        annexeCategory: action.category
      };
    }

    case `SAVE_SLIDE_COMPOSITION_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_SLIDE_COMPOSITION_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_SLIDE_COMPOSITION_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }
    case "FETCH_SLIDE_PENDING": {
      return {
        ...state,
        fetchSlide: {
          fetched: false,
          fetching: true
        }
      };
    }
    case "FETCH_SLIDE_FULFILLED": {
      return {
        ...state,
        annexeCategory: null,
        componentConfig: {
          labels: { fr: "", en: "", nl: "" },
          type: "",
          indicators: [],
          config: [],
          data: []
        },
        ComponentAction: "ADD",
        fetchSlide: {
          fetched: true,
          fetching: false
        },
        error: null,
        slide: action.payload,
        composition: {
          ...state.composition,
          SlideIndicators: action.payload.indicators,
          labels: action.payload.labels,
          isPublic: action.payload.isPublic,
          isEditable: action.payload.isEditable,
          organizations: JSON.parse(action.payload.organizations),
          sideBar: "slideConfiguration",
          selectedComponent: "",
          layout: {
            ...state.composition.layout,
            type: action.payload.layout.type,
            components: action.payload.layout.components
          }
        }
      };
    }
    case "FETCH_SLIDE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        slide: [],
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/slideComposition.js